import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Location } from '@angular/common';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as fromRouting from './routing.actions';

@Injectable()
export class RoutingEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private location: Location
  ) {}

  go$ = createEffect(() => this.actions$.pipe(
    ofType(fromRouting.go),
    tap(action => {
      const { path, query: queryParams, extras } = action.routeData;
      if (action.extendOnly && !this.router.url.startsWith(`/${path[0]}`)) {
        return;
      }
      this.router.navigate(path, { queryParams, ...extras })
    })
  ), {
    dispatch: false
  });

  navigateToUrl$ = createEffect(() => this.actions$.pipe(ofType(fromRouting.navigateToUrl), tap(action => {
    const { url, extras } = action.urlNavigationData;
    this.router.navigateByUrl(url, extras)
  })), { dispatch: false });

  back$ = createEffect(() => this.actions$.pipe(
    ofType(fromRouting.back),
    tap(() => this.location.back())
  ), {
    dispatch: false
  });

  forward$ = createEffect(() => this.actions$.pipe(
    ofType(fromRouting.forward),
    tap(() => this.location.forward())
  ), {
    dispatch: false
  });
}
